var r=function(r){var t=r.split("/");return Number(t[t.length-1])};export{r as getIdFromKey};
//# sourceMappingURL=ReactTreeAccordion.helpers.js.map
